import React from 'react';
import { Link } from 'react-router-dom'; // Removed useNavigate
import Layout from '../../components/ui/Layout';
import { Container, Card, Row, Col, Button } from 'react-bootstrap';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation'; // Import Breadcrumb

export default function AdminLandingPage() {
  // const navigate = useNavigate(); // For potential back button if desired, though not typical for landing
  const breadcrumbItems = [
    { path: "/", label: "Home" },
    { label: "Admin Panel" } // Current page
  ];

  return (
    <Layout>
      <Container className="mt-4">
        <BreadcrumbNavigation items={breadcrumbItems} />
        {/* Optional Back Button if you want one even on this landing page */}
        {/* <Button variant="outline-secondary" onClick={() => navigate(-1)} className="mb-3">&larr; Go Back</Button> */}
        <h1 className="mb-4">Admin Panel</h1>
        <p>Welcome to the administration panel. Please choose a section to manage.</p>
        <Row xs={1} md={2} lg={3} className="g-4">
          <Col>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column">
                <Card.Title>User Management</Card.Title>
                <Card.Text>
                  Manage user accounts, roles, and assignments.
                </Card.Text>
                <Button as={Link} to="/admin/dashboard" variant="primary" className="mt-auto">Go to User Dashboard</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column">
                <Card.Title>Supermarket Management</Card.Title>
                <Card.Text>
                  Manage supermarket listings, details, and media.
                </Card.Text>
                <Button as={Link} to="/admin/supermarkets" variant="primary" className="mt-auto">Manage Supermarkets</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column">
                <Card.Title>Product Management</Card.Title>
                <Card.Text>
                  Manage product listings, details, and media.
                </Card.Text>
                <Button as={Link} to="/admin/products" variant="primary" className="mt-auto">Manage Products</Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column">
                <Card.Title>Unprocessed Payments</Card.Title>
                <Card.Text>
                  Review pending WiPay callbacks and manually resolve payments as successful or failed.
                </Card.Text>
                <Button as={Link} to="/admin/unprocessed-payments" variant="primary" className="mt-auto">
                  Resolve Payments
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column">
                <Card.Title>Reports</Card.Title>
                <Card.Text>
                  Generate order and sales reports by date range.
                </Card.Text>
                <Button as={Link} to="/admin/reports" variant="primary" className="mt-auto">
                  View Reports
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
